const API_URL = process.env.REACT_APP_API_URL || 'https://api.ginoboxingstudio.com';

/**
 * Ouvre le portail de facturation Stripe : mise à jour de la carte et
 * règlement des factures impayées après un échec de prélèvement.
 * Redirige l'onglet courant, Stripe renvoyant ensuite vers /dashboard/subscriptions.
 */
export async function openBillingPortal(jwt) {
  const response = await fetch(`${API_URL}/api/subscription-portal-session`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${jwt}`,
      'Content-Type': 'application/json',
    },
  });

  const result = await response.json();

  if (!response.ok || !result?.url) {
    throw new Error(
      result?.error?.message || "Impossible d'ouvrir la gestion de votre abonnement. Contactez le studio."
    );
  }

  window.location.href = result.url;
}

/**
 * Message d'alerte à afficher selon l'état de l'abonnement, ou null si tout va
 * bien. `inGrace` : l'accès tient encore, mais la tolérance court.
 */
export function paymentIssueMessage(subscriptionState) {
  if (!subscriptionState?.needsPayment) {
    return null;
  }

  const deadline = subscriptionState.graceUntil
    ? new Date(subscriptionState.graceUntil).toLocaleDateString('fr-FR', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })
    : null;

  if (subscriptionState.inGrace) {
    return {
      severity: 'warning',
      title: 'Le prélèvement de votre abonnement a échoué',
      body: deadline
        ? `Vos réservations restent possibles jusqu'au ${deadline}. Passé ce délai, l'accès aux cours sera suspendu.`
        : "Vos réservations restent possibles quelques jours. Passé ce délai, l'accès aux cours sera suspendu.",
    };
  }

  return {
    severity: 'error',
    title: 'Votre abonnement est suspendu',
    body: "Le prélèvement de votre abonnement a échoué et n'a pas été régularisé. Mettez à jour votre moyen de paiement pour réserver à nouveau.",
  };
}
